import { Text } from '@react-email/components';

const Preheader = ({ preheader }: { preheader: string }) => {
  return (
    <Text
      style={{
        display: 'none',
        fontSize: '1px',
        lineHeight: '1px',
        maxHeight: '0px',
        maxWidth: '0px',
        opacity: 0,
        overflow: 'hidden',
        visibility: 'hidden',
      }}
    >
      {preheader}
      {Array(100).fill('\u200C\u00A0').join('')}
    </Text>
  );
};

export default Preheader;
